import _ from 'lodash';
import TrendingUp from '@mui/icons-material/TrendingUp';

const routes = {
    LANDING: {
        path: '/',
        icon: TrendingUp,
        subtitle: 'global.dashboard'
    },
    LOGOUT: {
        path: '/logout',
    },
    RESET_PASSWORD: {
        path: '/password-reset/:token',
    },
    REGISTRATION: {
        path: '/user/:userId/confirmation',
    }
};

export const LANDING = routes.LANDING;
export const LOGOUT = routes.LOGOUT;
export const RESET_PASSWORD = routes.RESET_PASSWORD;
export const REGISTRATION = routes.REGISTRATION;

export default Object.values(routes);

export function routeTo(path, props) {
    const prevPath = _.get(props, 'location')
        ? _.get(props, 'location.pathname', '') + _.get(props, 'location.search', '')
        : undefined;
    props.history.push(path, {prevPath});
}

export function prevPath(props) {
    return _.get(props, 'location.pathname', '') + _.get(props, 'location.search', '');
}

export function newTab(path) {
    window.open(window.location.origin + path, '_blank');
}
